import { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import Layout from './Dashboard/Layout';
import Home from './Dashboard/Home';
import QuotesTable from './Dashboard/QuotesTable';
import SpotQuotesForm from './Dashboard/SpotQuotesForm';
import BookedShipmentsTable from './Dashboard/BookedShipmentsTable';
import ContactLanding from './Landing/Contact';
import ContactWebApp from './Dashboard/Contact';
import LoginForm from './Landing/LoginForm';
import LandingPage from './Landing/LandingPage';
import ResetPasswordRequestForm from './Landing/ResetPasswordRequestForm'; // Import the ResetPasswordRequestForm component
import ResetPasswordForm from './Landing/ResetPasswordForm'; // Import the ResetPasswordForm component
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import IdleTimeoutWrapper from './components/IdleTimeoutWrapper';

const RedirectToHome = () => {
    const { loggedIn } = useContext(AuthContext);
    return loggedIn ? <Navigate to="/tms/home" replace /> : <Navigate to="/tms/login" replace />;
};

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Landing Page */}
                    <Route path="/" element={<LandingPage />} />

                    {/* Contact Page */}
                    <Route path="/contact" element={<ContactLanding />} />

                    {/* Redirect /tms to /tms/home if logged in */}
                    <Route path="/tms" element={<RedirectToHome />} />

                    {/* Login Page */}
                    <Route path="/tms/login" element={<LoginForm />} />

                    {/* Password Reset Request Pages */}
                    <Route path="/tms/reset-password" element={<ResetPasswordRequestForm />} />
                    <Route path="/tms/reset-password/:token" element={<ResetPasswordForm />} />

                    {/* Authenticated routes with idle timeout */}
                    <Route
                        path="/tms/*"
                        element={
                            <IdleTimeoutWrapper timeout={600000}> {/* 10 minutes */}
                                <Layout>
                                    <Routes>
                                        <Route path="home" element={<Home />} />
                                        <Route path="quotes" element={<QuotesTable />} />
                                        <Route path="spot-quotes" element={<SpotQuotesForm />} />
                                        <Route path="booked-shipments" element={<BookedShipmentsTable />} />
                                        <Route path="contact" element={<ContactWebApp />} />
                                        {/* Catch-all route */}
                                        <Route path="*" element={<Navigate to="/tms/home" replace />} />
                                    </Routes>
                                </Layout>
                            </IdleTimeoutWrapper>
                        }
                    />

                    {/* Catch-all route for unmatched paths */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;
